var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "configuration" },
    [
      _vm.dataloaded && _vm.isInEditMode
        ? _c(
            "modal-box",
            {
              attrs: {
                open: _vm.dataloaded && _vm.isInEditMode,
                width: "1080px",
              },
              domProps: {
                onClose: _vm.closeModal,
                enableHeader: true,
                enableFooter: true,
                enableHeaderClose: true,
                transparentOverlay: false,
                closeOnClickOutside: true,
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "line-height": "var(--adam-d48)" },
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("div", { staticClass: "flex-row flex-1" }, [
                    _c("div", { staticClass: "flex-col flex-1" }, [
                      _c("h3", [_vm._v(_vm._s(_vm.configModel.uiText))]),
                    ]),
                  ]),
                ]
              ),
              _c("span", [
                _c("div", { staticClass: "flex-col edit-config" }, [
                  _c("div", { staticClass: "mt-3 config" }, [
                    _c(
                      "label",
                      {
                        staticClass: "config-label",
                        attrs: { for: "configOldValue" },
                      },
                      [_vm._v(_vm._s(_vm.$t("oldValue")))]
                    ),
                    _c("input", {
                      staticClass: "config-input",
                      attrs: {
                        id: "configOldValue",
                        placeholder: "Value",
                        readonly: true,
                      },
                      domProps: { value: _vm.configOldValue },
                    }),
                  ]),
                  _c("div", { staticClass: "mt-3 config" }, [
                    _c(
                      "label",
                      {
                        staticClass: "config-label",
                        attrs: { for: "configValue" },
                      },
                      [_vm._v(_vm._s(_vm.$t("newValue")))]
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configModel.value,
                          expression: "configModel.value",
                        },
                      ],
                      staticClass: "config-input",
                      attrs: { id: "configValue", placeholder: "Value" },
                      domProps: { value: _vm.configModel.value },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.configModel,
                            "value",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "mt-3 config" }, [
                    _c(
                      "label",
                      {
                        staticClass: "config-label",
                        attrs: { for: "configReason" },
                      },
                      [_vm._v(_vm._s(_vm.$t("reason")) + "*")]
                    ),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configModel.updComment,
                          expression: "configModel.updComment",
                        },
                      ],
                      staticClass: "config-input",
                      attrs: {
                        id: "configReason",
                        placeholder: "Reason",
                        rows: "4",
                      },
                      domProps: { value: _vm.configModel.updComment },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.configModel,
                            "updComment",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { class: _vm.errorExists ? "error-text" : "" }, [
                    _vm.errorExists
                      ? _c("div", [_vm._v("This field is mandatory")])
                      : _vm._e(),
                  ]),
                ]),
                _c("br"),
              ]),
              _c(
                "span",
                {
                  staticStyle: { "line-height": "var(--adam-d48)" },
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("div", { staticClass: "flex-row reverse" }, [
                    _c(
                      "div",
                      { staticClass: "flex-col flex-align-end" },
                      [
                        _c(
                          "adam-button",
                          {
                            attrs: { secondary: "", icon: "ic-station" },
                            on: { click: _vm.save },
                          },
                          [_vm._v("Save")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      !_vm.dataloaded
        ? _c("div", { staticClass: "popup" }, [_c("eas-loader")], 1)
        : _c("content-wrapper", {
            scopedSlots: _vm._u([
              {
                key: "filters",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "flex-row reverse flex-1",
                        staticStyle: { "align-items": "center" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "flex-col mr-4",
                            staticStyle: { "align-items": "flex-end" },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.pageSize,
                                    expression: "pageSize",
                                  },
                                ],
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.pageSize = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    _vm.changePageSize,
                                  ],
                                },
                              },
                              _vm._l(_vm.pageSizeSelection, function (size) {
                                return _c(
                                  "option",
                                  { key: size, domProps: { value: size } },
                                  [_vm._v(_vm._s(size))]
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "flex-col pagesizelebel pr-2" },
                          [_vm._v("Page Size: ")]
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "content",
                fn: function () {
                  return [
                    _c("div", { staticClass: "main-body mb-4" }, [
                      _c("div", { staticClass: "flex-row" }, [
                        _c("div", { staticClass: "flex-col flex-1" }),
                        _c(
                          "div",
                          { staticClass: "flex-col flex-12" },
                          [
                            _c("paging", {
                              attrs: { pagingData: _vm.pagingData },
                              on: { "current-page": _vm.modifyContent },
                              scopedSlots: _vm._u([
                                {
                                  key: "pageContent",
                                  fn: function () {
                                    return _vm._l(
                                      _vm.configModelList,
                                      function (config) {
                                        return _c("ConfigValueEdit", {
                                          key: config.sNo,
                                          attrs: { configModel: config },
                                          on: { "on-edit": _vm.editConfig },
                                        })
                                      }
                                    )
                                  },
                                  proxy: true,
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "flex-col flex-1" }),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }